import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './prompt.module.css';
import icSunshine from './ic_sunshine.png';
import defaultIconDuoren from './ic_touxiang_duoren.png';
import defaultIconDanren from '../../../img/bee.png';
import bg_stu_red from './bg_stu_red.png';
import bg_stu_gray from './bg_stu_gray.png';
import audio from './success.mp3';
import MyImg from '../../myimg/myimg.jsx';

class Prompt extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, []);

        this.state = {
            reasonList: []
        };

    }

    componentDidMount () {
        const audio = document.getElementById(`audio`);
        audio.play();
    }

    render () {
        return (
            <div className={styles['backgroud-layer']}>

                <div className={styles.container}>


                    <audio
                        id='audio'
                        src={audio}
                        preload={"auto"}
                    >
                    </audio>


                {this.props.type == '1' ?
                    <img className={styles.xuanzhun} src={icSunshine}/>
                    : null}


                    <MyImg
                        type='result'
                    src={this.props.student_img==''||this.props.student_img==null? this.props.duorenStatus?defaultIconDuoren:defaultIconDanren:this.props.student_img}
                    />

                {/*<img*/}
                    {/*className={styles['img-touxiang']}*/}
                    {/*src={this.props.student_img==''||this.props.student_img==null? this.props.duorenStatus?defaultIconDuoren:defaultIconDanren:this.props.student_img}*/}
                {/*/>*/}

                {this.props.type == '1' ?
                    <img
                        className={styles['bg-name']}
                        src={bg_stu_red}
                    />
                    : null}

                {this.props.type == '2' ?
                    <img
                        className={styles['bg-name']}
                        src={bg_stu_gray}
                    />
                    : null}


                <div className={styles['text-name']}>{this.props.student_name}</div>
                <div className={styles['div-bottom']}>
                    {/*<div className={styles['div-img-reason']}>*/}
                        {/*<img*/}
                            {/*className={styles['img-reason']}*/}
                            {/*src={this.props.img}*/}
                        {/*/>*/}
                    {/*</div>*/}
                    {/*<div className={styles['text-reason']}>{this.props.reason_name}</div>*/}
                    {
                        this.props.type == '1' ? <div className={styles['text-num-blue']}>评价成功</div> : null
                    }
                    {
                        this.props.type == '2' ? <div className={styles['text-num-red']}>评价成功</div> : null
                    }
                </div>

                </div>
            </div>
        );
    }
}


export default Prompt;
